import { useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";
import { useShallow } from "zustand/shallow";

import { Indicator } from "@src/components/Indicator";

import { useListener } from "@src/hooks/useListener";

import { usePlayerState } from "@src/states/player";

import { player } from "@src/services/player";
import { DEFAULT_TRACK_ID } from "@src/services/player/constants";
import { StreamProxy } from "@src/services/streamProxy";

import { setupOnlineMode } from "@src/utils/online/setupOnlineMode";

export function ProxyIndicator() {
  const [currentTrackObj, currentTrackId] = usePlayerState(
    useShallow((state) => [
      state.tracks[state.currentTrackId],
      state.currentTrackId,
    ]),
  );
  const playingOrPaused = player.getPlayingOrPaused(currentTrackId);
  const isOnlinePlaying = currentTrackId === DEFAULT_TRACK_ID;
  const hasProxy = useMemo(
    () => StreamProxy.hasProxy(currentTrackObj?.url),
    [currentTrackObj?.url],
  );

  const queryClient = useQueryClient();
  useListener("changeTrack", () => {
    if (isOnlinePlaying && hasProxy) {
      console.log(
        "Aproveitando a troca de música para tentar dispensar o proxy...",
      );
      player.removeTrack(DEFAULT_TRACK_ID).then(() => {
        setupOnlineMode(queryClient, false);
        if (playingOrPaused === "playing") {
          player.play(DEFAULT_TRACK_ID);
        }
      });
    }
  });

  if (!isOnlinePlaying || playingOrPaused !== "playing") {
    return <></>;
  }
  return (
    <Indicator
      color={hasProxy ? "yellow" : "green"}
      text={hasProxy ? "Com Proxy" : "Sem Proxy"}
    />
  );
}
